import { ResultContent } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { ModalComponentWrapper } from '@/shared/components';
import { useModalStore } from '@/shared/lib';
import type { CreateApiTokenResponseDto } from './types';
import { CreateApiTokenResultDetails } from '../ui';

type SuccessScreenProps = {
  apiToken: CreateApiTokenResponseDto;
  onBack: () => void;
};

const useCreateApiTokenResult = () => {
  const { showDialogComponent } = useModalStore();
  const { t } = useTranslation();

  const goToSuccessScreen = ({ apiToken, onBack }: SuccessScreenProps) => {
    if (!apiToken) return;

    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            onClick={onBack}
            title={t('webApiTokens.creation.success.title')}
            description={t('webApiTokens.creation.success.description')}
            buttonText={t('webApiTokens.creation.success.buttonText')}
            buttonVariant="secondary"
            className="h-auto">
            <CreateApiTokenResultDetails apiToken={apiToken} />
          </ResultContent>
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
  };
};

export { useCreateApiTokenResult };
